import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  // No agregar token a requests de auth (login, register, etc.)
  if (req.url.includes('/auth/')) {
    return next(req);
  }

  // Agregar token si existe
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(req).pipe(
    catchError((error) => {
      // Dejamos que cada componente maneje 401 para evitar logout involuntario
      // cuando el backend responde 401 por permisos de una ruta específica.
      return throwError(() => error);
    }),
  );
};
